import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/ListingRulePreview.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/listing/preview/rules`;
	}
	create(e, t = {}) {
		return this.api.post(this.buildPath(n.baseUrl, t), e);
	}
	update(e, t, r = {}) {
		return this.api.put(this.buildPath(`${n.baseUrl}/${e}`, r), t);
	}
	get(e, t, r = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}`, {
			...t,
			...r
		}));
	}
};
//#endregion
export { n as ListingRulePreview };

//# sourceMappingURL=ListingRulePreview.js.map